import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopWalletTransactionFragment = { __typename: 'ShopWalletTransactionObject', id: number, amount: number, state: Types.WalletTransactionState, description?: string | null | undefined, currency: string, createdAt: any, finalizedAt?: any | null | undefined };

export type ShopWalletFragment = { __typename: 'ShopWalletObject', id: number, balance: number, currency: string, createdAt: any, transactions: Array<{ __typename: 'ShopWalletTransactionObject', id: number, amount: number, state: Types.WalletTransactionState, description?: string | null | undefined, currency: string, createdAt: any, finalizedAt?: any | null | undefined }> };

export type ShopWalletQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  currency: Types.Scalars['String']['input'];
}>;


export type ShopWalletQuery = { __typename: 'Query', shopWallet?: { __typename: 'ShopWalletObject', id: number, balance: number, currency: string, createdAt: any, transactions: Array<{ __typename: 'ShopWalletTransactionObject', id: number, amount: number, state: Types.WalletTransactionState, description?: string | null | undefined, currency: string, createdAt: any, finalizedAt?: any | null | undefined }> } | null | undefined };

export type ShopWalletsQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ShopWalletsQuery = { __typename: 'Query', shopWallets: Array<{ __typename: 'ShopWalletObject', id: number, balance: number, currency: string, createdAt: any, transactions: Array<{ __typename: 'ShopWalletTransactionObject', id: number, amount: number, state: Types.WalletTransactionState, description?: string | null | undefined, currency: string, createdAt: any, finalizedAt?: any | null | undefined }> }> };

export type CreateShopWalletPaymentMutationVariables = Types.Exact<{
  input: Types.ShopCreateWalletPaymentInput;
}>;


export type CreateShopWalletPaymentMutation = { __typename: 'Mutation', shopCreateWalletPayment: { __typename: 'ShopWalletTransactionObject', id: number, amount: number, state: Types.WalletTransactionState, description?: string | null | undefined, currency: string, createdAt: any, finalizedAt?: any | null | undefined } };

export const ShopWalletTransactionFragmentDoc = gql`
    fragment ShopWalletTransaction on ShopWalletTransactionObject {
  id
  amount
  state
  description
  currency
  createdAt
  finalizedAt
}
    `;
export const ShopWalletFragmentDoc = gql`
    fragment ShopWallet on ShopWalletObject {
  id
  balance
  currency
  createdAt
  transactions {
    ...ShopWalletTransaction
  }
}
    ${ShopWalletTransactionFragmentDoc}`;
export const ShopWalletDocument = gql`
    query ShopWallet($userId: Int!, $currency: String!) {
  shopWallet(userId: $userId, currency: $currency) {
    ...ShopWallet
  }
}
    ${ShopWalletFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopWalletGQL extends Apollo.Query<ShopWalletQuery, ShopWalletQueryVariables> {
    document = ShopWalletDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopWalletsDocument = gql`
    query ShopWallets($userId: Int!) {
  shopWallets(userId: $userId) {
    ...ShopWallet
  }
}
    ${ShopWalletFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopWalletsGQL extends Apollo.Query<ShopWalletsQuery, ShopWalletsQueryVariables> {
    document = ShopWalletsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShopWalletPaymentDocument = gql`
    mutation CreateShopWalletPayment($input: ShopCreateWalletPaymentInput!) {
  shopCreateWalletPayment(input: $input) {
    ...ShopWalletTransaction
  }
}
    ${ShopWalletTransactionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShopWalletPaymentGQL extends Apollo.Mutation<CreateShopWalletPaymentMutation, CreateShopWalletPaymentMutationVariables> {
    document = CreateShopWalletPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }